import { enumServe } from "@/service"
import { defineStore } from "pinia"

export const useInfoStore = defineStore("info", {
  state: () => ({
    enums: {},
    degreeEnum: null,
    degreeStatus: null
  }),
  getters: {
    getDegree: (state) => (value) => {
      if (state.degreeEnum) {
        const res = state.degreeEnum.find((item) => item.key === value)
        return res ? res.value : null
      }
      return null
    },
    getDegreeStatus: (state) => (value) => {
      if (state.degreeStatus) {
        const res = state.degreeStatus.find((item) => item.key === value)
        return res ? res.value : null
      }
      return null
    }
  },
  actions: {
    async queryDegreeEnum() {
      if (this.degreeEnum) {
        return this.degreeEnum
      } else {
        const res = await enumServe.getDegreeType()
        this.degreeEnum = res.data
        return this.degreeEnum
      }
    },
    async queryDegreeStatus() {
      if (this.degreeStatus) {
        return this.degreeStatus
      } else {
        const res = await enumServe.getDegreeStatus()
        this.degreeStatus = res.data
        return this.degreeStatus
      }
    },
    getMerchantEnums() {
      enumServe.merchant.init().then((res) => {
        this.enums = {
          ...this.enums,
          ...res
        }
      })
    },
    getAllEnums() {
      enumServe.allEnums().then((res) => {
        const { success, data } = res
        if (success) {
          const maps = Object.keys(data).reduce((maps, key) => {
            const items = data[key].map((item) => {
              const { enum_key, enum_value, order_id, dict } = item
              return {
                value: enum_key,
                label: enum_value,
                order: order_id,
                dictId: dict
              }
            })
            maps[key] = items.sort((a, b) => a.order - b.order)
            return maps
          }, {})

          this.enums = { ...this.enums, ...maps }
        }
      })
    },
    getCommonAres() {
      enumServe.commonAreas().then((res) => {
        const { success, data } = res
        if (success) {
          const areas = data.map(({ id, name, adminDept }) => {
            return { value: id, label: name, deptId: adminDept.id }
          })
          this.enums.commonAreas = areas
        }
      })
    },
    getModuleArea(params, key = "moduleAreas") {
      this.enums[key] = []
      /* 各模块特有地区 */
      enumServe.commonAreas(params).then(({ data = [] }) => {
        this.enums[key] = data.map((item) => {
          const { id, name } = item
          return { value: id, label: name }
        })
      })
    }
  }
})
